
@if (MenuOriginal.length >0 ) {
  <div>
    <nav  class="sidebar">
      <ng-container>
        <header>
          <div class="image-text">
            <span (click)="onIndex()" class="image" >
              <img class="rotate-360 logo-primario" [src]="parametros.logo_primario || 'assets/default-logo.webp'" alt="logo">
            </span>
            <div class="text header-text">
              <span class="name">{{parametros.nombre || "[Nombre Compañía]"}}</span>
              <span class="name"> {{name}}</span>
            </div>
          </div>
          <i (click)="toggle()" class="bx bx-chevron-right toggle"></i>
        </header>
        <div  class="menu-bar">
          <div class="menu">
            <li class="search-box">
              <a href="javascript:void(0)">
                <i (click)="toggleSearch('buscar')" class='bx bx-search icon' ></i>
                <input  (input)="getText($event.target)" class="text-search" type="text" placeholder="Buscar...">
              </a>
            </li>
            @for (menuItem of cloneMenu; track menuItem) {
              <app-menu-item
                [menuItem]="menuItem"
                [flagSidebar]="flagSidebar"
                (clickEmit)="getClick($event)"
                [isChildren]="false"
                (onAccionMiniNav)="getOnAccionMiniNav($event)"
              ></app-menu-item>
            }
            @if (cloneMenu.length == 0) {
              <div style="display: flex; justify-content: center; align-items: center; height: 60vh; text-align: center;">
                <p>No se encontraron coincidencias</p>
              </div>
            }
          </div>
          <div class="botton-content">
            <li class="logout">
              <a class="btn-cerrar-sesion" href="javascript:void(0)" (click)="logout()">
                <i class='bx bx-log-out icon' ></i>
                <span class="text nav-text">Cerrar sesión</span>
              </a>
            </li>
            <li class="mode">
              <div class="moon-sun">
                <i [ngClass]="iconMode" class='bx icon moon' ></i>
              </div>
              <span class="mode-text text">Modo {{textMode}}</span>
              <div (click)="modeSwitch()" class="toggle-switch">
                <span class="switch"></span>
              </div>
            </li>
          </div>
        </div>
      </ng-container>
    </nav>
    @if (!flagSidebar) {
      <section class="empty-section" (click)="toggle()"></section>
    }
    <section class="home miga-section" [ngClass]="{'breadcrumb-fixed': isBreadcrumbFixed}" style="height: 55px;">
      @if (this.breadCrumb.length > 0) {
        <div class="container-breadcrumb" >
          <p-breadcrumb
            [style]="{'white-space': 'nowrap', 'overflow': 'auto', 'font-weight':'500'}"
          [model]="breadCrumb" (onItemClick)="customBreadCrumbLink($event)" [home]="home"></p-breadcrumb>
          <i [pTooltip]=" isBreadcrumbFixed ? 'desanclar' : 'anclar' " class='bx pin-icon bx-pin' [ngClass]="{'icon-fixed': isBreadcrumbFixed}" (click)="toggleBreadcrumbFixed()"></i>
        </div>
      }
    </section>
    <section class="home screen" [ngClass]="{'add-padding-top': isBreadcrumbFixed}">
      @if (showScreenInit) {
        <div class="screen-init">
          <img class="image-login" [src]="parametros.logo_horizontal_secundario || 'assets/default-logo.webp'" alt="logo">
        </div>
      }
      <router-outlet ></router-outlet>
    </section>
  </div>
} @else {
  <nav  class="sidebar">
    <ng-container>
      <header>
        <div class="image-text">
          <span (click)="onIndex()" class="image" >
            <div class="p-skeleton p-component p-skeleton-circle" style="width: 5rem; height: 5rem;"></div>
          </span>
          <div class="text header-text">
            <div class="p-skeleton p-component mb-2" style="width: 10rem; height: 1.5rem;"></div>
            <div class="p-skeleton p-component mb-2" style="width: 5rem; height: 1.5rem;"></div>
          </div>
        </div>
      </header>
      <div class="skeleton-container">
        <div class="skeleton-menu">
          <div class="p-skeleton p-component mt-4" style="height: 4rem;"></div>
          <div style="padding: 5px;">
            <div class="p-skeleton p-component mt-5" style="height: 3.5rem;"></div>
            <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
            <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
            <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
            <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
          </div>
        </div>
        <div class="skeleton-footer">
          <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
          <div class="p-skeleton p-component mt-3" style="height: 3.5rem;"></div>
        </div>
      </div>
    </ng-container>
  </nav>
}




